import { defineMessages } from 'react-intl';

export default defineMessages({
  status: {
    id: 'legal_proceedings_page.judgement_on_merits.decision.status',
  },
  contestationReason: {
    id: 'legal_proceedings_page.judgement_on_merits.decision.contest_reason',
  },
  contestationInstruction: {
    id:
      'legal_proceedings_page.judgement_on_merits.decision.contest_instruction',
  },
  decision: {
    id: 'legal_proceedings_page.judgement_on_merits.decision.title',
  },
  challenged: {
    id: 'legal_proceeding_page.judgement_on_merits.recap.title.challenged',
  },
  calculatedPrejudiceMoralTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits_info_title.calculated_prejudice_moral',
  },
  calculatedPrejudiceMaterielTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits_info_title.calculated_prejudice_materiel',
  },
  prejudiceMoralTitle: {
    id: 'legal_proceeding_page.judgement_on_merits_info_title.prejudice_moral',
  },
  prejudiceMaterielTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits_info_title.prejudice_materiel',
  },
  checkBoxTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits.civil_judgement.check_box_title',
  },
  victimFrais: {
    id: 'preopening_page.victim.frais',
  },
  victimTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.ayant_droit_victim',
  },
  judgementAmountBeneficiary: {
    id:
      'legal_proceeding_page.judgement_on_merits.beneficiary.judgement_amount',
  },
  fullname: {
    id: 'preopening_page.beneficiary_fullname',
  },
  age: {
    id: 'preopening_page.beneficiary_age',
  },
  funeralCosts: {
    id: 'legal_proceeding_page.judgement_on_merits.funeral_cots',
  },
  addBeneficiaryBtn: {
    id: 'preopening_page.victim.add_beneficiary',
  },
  beneficiaryAccordionTitle: {
    id: 'preopening_page.beneficiary_accordion_title',
  },
  victimFirstName: {
    id: 'preopening_page.victim.first_name',
  },
  victimLastName: {
    id: 'preopening_page.victim.last_name',
  },
  saveBtn: {
    id: 'preopening_page.save',
  },
  beneficiaryAge: {
    id: 'preopening_page.beneficiary_age',
  },
  cancelBtn: {
    id: 'preopening_page.cancel',
  },
  deleteBtn: {
    id: 'preopening_page.delete',
  },
  successDialogPrimaryButtonTitleJdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  qualityBeneficiary: {
    id: 'preopening_page.victim.qualityBeneficiary',
  },
  challenge: {
    id: 'legal_proceeding_page.judgement_on_merits.recap.title.challenge',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  victimFullName: {
    id: 'legal_proceeding_page.judgement_on_merits_deceased_victims_title',
  },
  referenceCapital: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_reference_capital',
  },
  calculatedEvaluation: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_calculated_evaluation',
  },
  judiciaryEvaluation: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_judiciary_evaluation',
  },
  medicalFees: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_medical_fees',
  },
  funeralFees: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_funeral_fees',
  },
  responsabilityShare: {
    id:
      'legal_proceeding_page.judgement_on_merits_deceased_victims_responsability_share',
  },
  agePartnerValidation: {
    id: 'victim.add_beneficiary_age_validation',
  },
  responsibiltySharePercentage: {
    id: 'preopening_page.claim_circumstances.responsibilty_percentage',
  },
  injuredVictim: {
    id: 'legal_proceeding_page.judgement_on_merits_injured_victims_title',
  },
  revenueFieldTitle: {
    id: 'legal_proceeding_page.judgement_on_merits.revenue_field',
  },
  reasonField: {
    id: 'legal_proceeding_page.judgement_on_merits.reason',
  },
  judiciaryAmount: {
    id: 'legal_proceeding_page.judgement_on_merits.judiciary_amount_field',
  },
  calculatedCompensationFieldTitle: {
    id:
      'legal_proceeding_page.judgement_on_merits.calculated_compensation_field',
  },
  sharedResponsability: {
    id: 'legal_proceeding_page.judgement_on_merits_shared_responsibility_title',
  },
  deceasedVictims: {
    id: 'legal_proceeding_page.judgement_on_merits_deceased_victims_title',
  },
  beneficiaryBirthDate: { id: 'preopening_page.beneficiary.date_of_birth' },
  beneficiaryConsistencyError: {
    id:
      'legal_proceeding_page.judgement_on_merits.beneficiary.check_consistency_error',
  },
  victimConsistencyError: {
    id:
      'legal_proceeding_page.judgement_on_merits.victim.check_consistency_error',
  },
  beneficiariesAlert: {
    id: 'legal_proceeding_page.judgement_on_merits.beneficiary.alert',
  },
  substantiveValidationError: {
    id:
      'legal_proceeding_page.judgement_on_merits.desceased_victim.substantive_error',
  },
  formValidationError: {
    id: 'legal_proceeding_page.judgement_on_merits.desceased_victim.form_error',
  },
  invalidDate: {
    id: 'preopening_page.invalid_date',
  },
  compensationRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.civil_judgement',
  },
  formRejectionRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.form_rejection',
  },
  substantiveRejectionRadioLabel: {
    id: 'legal_proceeding_page.judgement_on_merits.substantive_rejection',
  },
  ageBeneficiaryValidation: {
    id: 'victim.add_beneficiary_age_validation',
  },
});
